export default {
  SET_USERS(state, users) {
    state.users = users
  },
  REMOVE_RECORD(state, itemId) {
    const userIndex = state.users.findIndex((u) => u._id == itemId)

    state.users.splice(userIndex, 1)
  },
  UPDATE_USER(state, data) {
    const userIndex = state.users.findIndex((u) => u.userID === data.user.userID)

    if (data.path != '') state.users[userIndex].avatar = data.path
    // if (data.user.userID == this.$store.state.AppActiveUser) localStorage.setItem('userInfo') = state.users[userIndex]
  },
  APPROVE_USER_PAYMENT(state, data) { 
    const userIndex = state.users.findIndex((u) => u._id === data)
    state.users[userIndex].paymentStatus = 'Approved'
  },
  REJECT_USER_PAYMENT(state, data) { 
    const userIndex = state.users.findIndex((u) => u._id === data)
    state.users[userIndex].paymentStatus = 'Rejected'
  },
  APPROVE_USER(state, data) { 
    const userIndex = state.users.findIndex((u) => u._id === data)
    state.users[userIndex].accountStatus = true
  },
  REJECT_USER(state, data) { 
    const userIndex = state.users.findIndex((u) => u._id === data)
    state.users[userIndex].accountStatus = false
  },
  PAY_TRANSACTION(state, data) { 
    const userIndex = state.users.findIndex((u) => u._id === data.itemId)
    state.users[userIndex].accountStatus = false
  },
  CHANGE_STATUS(state, data) {
    const userIndex = state.users.findIndex((u) => u._id === data.id) 
    state.users[userIndex].emailStatus = data.status
    state.users[userIndex].emailStatusComment = data.reason
  },
  CHANGE_REFER_STATUS(state, data) {
    const userIndex = state.users.findIndex((u) => u._id === data.id) 
    state.users[userIndex].emailStatus = data.status
    state.users[userIndex].emailStatusComment = data.reason
  }
}
